type Props = {
  fill: string;
  height: string;
  stroke: string;
  width: string;
};
const ResellerIcon = ({ fill, stroke, height, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37507 10.3724L6.82722 9.86018L6.76547 9.92623L6.72118 10.0051L7.37507 10.3724ZM7.37507 14L6.67902 14.2793C6.79311 14.5636 7.06869 14.75 7.37507 14.75V14ZM17.2822 14V14.75H17.5019L17.6869 14.6315L17.2822 14ZM12.4706 8.86089L13.0555 8.39147L12.4706 8.86089ZM10.4893 9.16319L9.74441 9.07601L9.73932 9.11945V9.16319H10.4893ZM8.50806 10.3724L7.96135 10.8858L8.08558 11.0181L8.25654 11.079L8.50806 10.3724ZM6.72118 10.0051C6.33408 10.6941 5.90982 12.3624 6.67902 14.2793L8.07113 13.7207C7.48174 12.2519 7.84998 11.0583 8.02896 10.7397L6.72118 10.0051ZM7.37507 14.75H17.2822V13.25H7.37507V14.75ZM17.6869 14.6315C18.0147 14.4214 18.4545 14.0129 18.6509 13.4312C18.8722 12.7755 18.7367 12.0377 18.1127 11.3713L17.0178 12.3965C17.1725 12.5617 17.223 12.6836 17.2401 12.755C17.2566 12.8237 17.2519 12.8855 17.2297 12.9515C17.176 13.1105 17.0215 13.2763 16.8776 13.3685L17.6869 14.6315ZM18.1127 11.3713C17.7326 10.9653 17.2766 10.7075 16.8319 10.5123C16.4076 10.326 15.906 10.1627 15.4903 10.009C14.6173 9.68627 13.7783 9.29214 13.0555 8.39147L11.8857 9.33031C12.8611 10.5457 14.0034 11.0585 14.9701 11.4159C15.4742 11.6023 15.8571 11.7225 16.2289 11.8857C16.5803 12.04 16.8319 12.1979 17.0178 12.3965L18.1127 11.3713ZM13.0555 8.39147C12.6854 7.93029 12.3122 7.58643 11.9207 7.40205C11.4915 7.19995 11.0276 7.18956 10.6227 7.43016C10.269 7.64037 10.0695 7.97972 9.95704 8.2453C9.83873 8.52462 9.77406 8.82262 9.74441 9.07601L11.2342 9.25037C11.2518 9.10069 11.2885 8.94776 11.3383 8.83031C11.3938 8.69912 11.4291 8.69586 11.389 8.71965C11.3598 8.73699 11.3199 8.74952 11.2805 8.74999C11.2453 8.75041 11.2427 8.7408 11.2816 8.7591C11.3742 8.80271 11.5765 8.94505 11.8857 9.33031L13.0555 8.39147ZM9.73932 9.16319C9.73932 9.24028 9.72205 9.39403 9.67099 9.53493C9.61691 9.68413 9.56526 9.71332 9.56998 9.7108L10.2765 11.034C10.7341 10.7897 10.9655 10.3654 11.0812 10.046C11.2 9.71836 11.2393 9.38841 11.2393 9.16319H9.73932ZM9.56998 9.7108C9.5215 9.73669 9.40163 9.76597 9.20236 9.75255C9.01492 9.73992 8.84193 9.69514 8.75958 9.66582L8.25654 11.079C8.45723 11.1504 8.7654 11.2265 9.10157 11.2492C9.42593 11.271 9.87213 11.2499 10.2765 11.034L9.56998 9.7108ZM9.05477 9.85897C8.87963 9.67247 8.57108 9.44643 8.1685 9.37651C7.71046 9.29697 7.22202 9.43791 6.82722 9.86018L7.92292 10.8846C7.9438 10.8623 7.95761 10.8521 7.96276 10.8487C7.96761 10.8455 7.96611 10.8472 7.95837 10.8499C7.95061 10.8525 7.94113 10.8545 7.93128 10.8551C7.92179 10.8557 7.915 10.8549 7.91184 10.8544C7.90895 10.8539 7.90969 10.8537 7.91402 10.8554C7.9184 10.8571 7.92483 10.8601 7.93264 10.8647C7.94046 10.8693 7.9478 10.8745 7.95389 10.8794C7.96018 10.8845 7.96267 10.8872 7.96135 10.8858L9.05477 9.85897Z"
        fill={fill}
      />
      <path
        d="M2.99991 16.0909C4.55301 19.5741 8.02842 22 12.0667 22C17.2176 22 21.4528 18.053 21.9509 12.9994"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 7.82821C19.4264 4.38841 15.967 2 11.9524 2C6.79046 2 2.5464 5.94861 2.04877 11.0037"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.098 16.032L2.26855 14.8765L1.11298 18.7059"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8365 8.04449L21.666 9.19995L22.8215 5.37047"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ResellerIcon;
